import React from 'react';
import { Field } from 'redux-form';
import CustomDropDownArray from '../../../../../utils/redux-forms-custom-fields/CustomDropDownArray';
import ArrayDropDown from '../../../../../utils/redux-forms-custom-fields/ArrayDropDown';
import CustomInput from '../../../../../utils/redux-forms-custom-fields/CustomInput';
import CustomDropDownGeneric from '../../../../../utils/redux-forms-custom-fields/CustomDropDownGeneric';
import CustomInputCheckbox from '../../../../../utils/redux-forms-custom-fields/CustomInputCheckbox';
import CustomDateTimePicker from '../../../../../utils/redux-forms-custom-fields/CustomDateTimePicker';
import { QUEST_TYPE_OPTIONS, STATUS_OPTIONS } from '../../constants/options';
import { arrayDropDownColors } from '../../../../../utils/constants';
import { DATE_STORE_FORMAT, DATE_DISPLAY_FORMAT } from '../../constants/dateFormats';
import { getCampaignOptions } from '../../constants/options';
const Details = ({
  handleTypeChange,
  titleSlug,
  handleStartChange,
  handleEndChange,
  questForm,
  streamingQuest,
  isNewTypeQuest,
  campaigns,
  renderTooltip,
  handleImageUpload,
  tab
}) => {

  const dateStoreFormat = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]'; // ISO 8601格式，与服务器匹配
  const dateDisplayFormat = 'MM-DD-YYYY HH:mm'; // 本地显示格式

  const campaignsOptions = () => getCampaignOptions(campaigns);
  return (
    <div className="info-tab-wrap" style={(tab === 'details') ? { display: 'block' } : { display: 'none' }}>
      <div className="form--row">
        <Field
          name="type"
          id="type"
          placeholder="Select Type"
          customLabel="Type"
          component={CustomDropDownArray}
          options={QUEST_TYPE_OPTIONS}
          onChange={(e, v) => handleTypeChange(v, questForm)}
        />
        <Field
          type="text"
          name="campaigns"
          id="campaigns"
          placeholder="Campaigns"
          customLabel="Campaigns"
          component={ArrayDropDown}
          styles={arrayDropDownColors}
          isMulti
          isClearable={false}
          optionsToRender={campaignsOptions()}
        />
      </div>
      <Field
        type="text"
        name="title"
        id="title"
        placeholder="Quest Title"
        customLabel={renderTooltip(
          'Quest Title',
          'This is what will show on the Quest Card, Modal page 1, My Quests, etc.'
        )}
        component={CustomInput}
        onChange={titleSlug}
      />
      <Field
        name="status"
        id="status"
        placeholder="Select Status"
        customLabel="Status"
        component={CustomDropDownGeneric}
        options={STATUS_OPTIONS}
      />
      <Field
        name="isPrivate"
        id="isPrivate"
        type="checkbox"
        placeholder="Select Value"
        customLabel="Is Private"
        component={CustomInputCheckbox}
      />
      <Field
        name="hideFrontpage"
        id="hideFrontpage"
        type="checkbox"
        placeholder="Select Value"
        customLabel="Hide In Frontpage"
        tooltip="If checked, this quest will absolutely not show up in the frontpage EVEN if it is private and the user is a member tier. Use this for hidden quests with Viewer Tiers."
        component={CustomInputCheckbox}
      />
      <Field
        type="text"
        name="startDateTime"
        id="startDateTime"
        placeholder="Start Date (Tracking)"
        dateStoreFormat={DATE_STORE_FORMAT}
        dateDisplayFormat={dateDisplayFormat}
        customLabel="Start Date (Tracking)"
        component={CustomDateTimePicker}
        onChange={(e, v) => handleStartChange(v)}
      />
      <Field
        type="text"
        name="endDateTime"
        id="endDateTime"
        placeholder="End Date (Tracking)"
        dateStoreFormat={DATE_DISPLAY_FORMAT}
        dateDisplayFormat={dateDisplayFormat}
        customLabel="End Date (Tracking)"
        component={CustomDateTimePicker}
        onChange={(e, v) => handleEndChange(v)}
      />
      <Field
        type="text"
        name="openRegistrationDate"
        id="openRegistrationDate"
        placeholder="Open Registration Date"
        dateStoreFormat={dateStoreFormat}
        dateDisplayFormat={dateDisplayFormat}
        customLabel="Open Registration Date"
        component={CustomDateTimePicker}
      />
      <Field
        type="text"
        name="closeRegistrationDate"
        id="closeRegistrationDate"
        placeholder="Close Registration Date"
        dateStoreFormat={dateStoreFormat}
        dateDisplayFormat={dateDisplayFormat}
        customLabel="Close Registration Date"
        component={CustomDateTimePicker}
      />
      <Field
        type="text"
        name="expectedPayoutDate"
        id="expectedPayoutDate"
        placeholder={isNewTypeQuest ? "Auto Payout Date" : "Expected Payout Date"}
        dateStoreFormat={dateStoreFormat}
        dateDisplayFormat={dateDisplayFormat}
        customLabel={isNewTypeQuest ? "Auto Payout Date" : "Expected Payout Date"}
        component={CustomDateTimePicker}
      />
      <Field
        type="text"
        name="group"
        id="group"
        placeholder="Group"
        customLabel="Group"
        component={CustomInput}
      />
      {streamingQuest && (
        <>
          <Field
            type="text"
            name="requiredBanner"
            id="requiredBanner"
            placeholder="Required Banner"
            customLabel={(
              <label>
                Required Banner
                <div
                  className="QuestEdit__upload"
                  onClick={() => handleImageUpload('banner')}
                  aria-hidden
                >
                  (Upload Banner)
                </div>
              </label>
            )}
            component={CustomInput}
          />
          <Field
            type="text"
            name="bannerLink"
            id="bannerLink"
            placeholder="Banner Link"
            customLabel="Banner Link"
            component={CustomInput}
          />
          <Field
            type="text"
            name="overlayImage"
            id="overlayImage"
            placeholder="Required Overlay Image"
            customLabel={(
              <label>
                Required Overlay Image
                <div
                  className="QuestEdit__upload"
                  onClick={() => handleImageUpload('overlay')}
                  aria-hidden
                >
                  (Upload Overlay Image)
                </div>
              </label>
            )}
            component={CustomInput}
          />
        </>
      )}
    </div>
  );
};

export default Details;